import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function useForceInit() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('force_init') == 'true') {
      localStorage.clear();
    }
  }, [searchParams]);

  return;
}

export default useForceInit;
